var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.types),function(type,i){return _c('div',{key:i},[(type === 'loader')?_c('div',{staticClass:"lds-ellipsis"},[_c('div'),_c('div'),_c('div'),_c('div')]):_c('div',{staticClass:"skeleton",class:_vm.typeToClass(type)})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }